// extracted by mini-css-extract-plugin
export default {"appWrapper":"App_appWrapper__fuhUs","gradient":"App_gradient__DKpfX"};